import React from "react";
import styled from "@emotion/styled";
import { compassColors } from "src/utils/styling";
import { fontP4Regular } from "src/design-system/styles/fonts";
import {
  breakpointDesktopOnly,
  breakpointWideDesktopOnly,
} from "src/design-system/styles/breakpoints";
import { Text } from "src/components/core/Text";

interface DisclaimerConfig {
  spanSymbol: string | React.ReactNode;
  i18nKey: string;
}

const Container = styled.div`
  width: 100%;
  background-color: ${compassColors.skyLite};
`;
const DisclaimerText = styled.p`
  ${fontP4Regular}
  margin-bottom: 18px;
  padding-left: 24px;
  padding-right: 24px;
  &:first-of-type {
    margin-top: 32px;
  }
  &:last-of-type {
    margin-bottom: 32px;
  }
  @media ${breakpointDesktopOnly} {
    padding-left: 80px;
    padding-right: 80px;
  }
  @media ${breakpointWideDesktopOnly} {
    padding-left: 120px;
    padding-right: 120px;
  }
`;

function Disclaimer() {
  const config = [
    {
      spanSymbol: "*",
      i18nKey: "t:introClinical:disclaimer:general:text1",
    },
    {
      spanSymbol: <sup>1</sup>,
      i18nKey: "t:introClinical:disclaimer:general:text2",
    },
    {
      spanSymbol: "†",
      i18nKey: "t:introClinical:disclaimer:general:text3",
    },
    {
      spanSymbol: "‡",
      i18nKey: "t:introClinical:disclaimer:general:text4",
    },
    {
      spanSymbol: <sup>2 </sup>,
      i18nKey: "t:introClinical:disclaimer:general:text5",
    },
    {
      spanSymbol: "",
      i18nKey: "t:introClinical:metforminFdaDisclaimer",
    },
  ];

  return (
    <Container>
      {config.map((item: DisclaimerConfig) => (
        <DisclaimerText key={item.i18nKey}>
          <span>{item.spanSymbol}</span>
          <Text i18nKeyOrText={item.i18nKey} />
        </DisclaimerText>
      ))}
    </Container>
  );
}

export default Disclaimer;
